import { safeParseNullDefault, safeParse } from 'shouldve-been-js';

class DepartmentLink {

    private _departmentId: string;
    private _status: string;

    public constructor(departmentId: string, status: string) {

        this._departmentId = departmentId;
        this._status = status;
    }

    public get departmentId(): string {
        return this._departmentId;
    }

    public set departmentId(value: string) {
        this._departmentId = value;
    }

    public get status(): string {
        return this._status;
    }

    public set status(value: string) {
        this._status = value;
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromJson(json: any): DepartmentLink | null {

        const departmentId: string | null = safeParseNullDefault<string>(json?.departmentId, '');
        const status: string = safeParse<string>(json?.status, '');
        
        if (departmentId === null || departmentId === '') {
            return null;
        }

        return new DepartmentLink(departmentId, status);
    }

    // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
    public static fromIndexedDB(object: any): DepartmentLink | null {

        const departmentId: string | null = safeParseNullDefault<string>(object?._departmentId, '');
        const status: string = safeParse<string>(object?._status, '');
        
        if (departmentId === null || departmentId === '') {
            return null;
        }

        return new DepartmentLink(departmentId, status);
    }
}

export default DepartmentLink;